const popupContainer = document.querySelector('.popupContainer');
function hidePopup() {
    popupContainer.classList.remove('open');
}
window.hidePopup = hidePopup;
// Endpoint Netlify
const apiUrl = '/.netlify/functions/getPosts?filter=info';
let currentPostCount = 6; // Początkowo wyświetlane 6 postów
const postContainer = document.getElementById('postContainer');
const loadMoreBtn = document.getElementById('loadMoreBtn');
const loader = document.getElementById('loader');
function showLoader() {
    loader.style.display = 'block';
}
function hideLoader() {
    loader.style.display = 'none';
    loadMoreBtn.style.display = 'block';
}
// Funkcja do pobierania postów
function fetchPosts() {
    showLoader();
    fetch(apiUrl).then((response)=>response.json()).then((posts)=>{
        loadPosts(posts); // Wywołaj funkcję do załadowania postów
    }).catch((error)=>console.error("B\u0142\u0105d pobierania post\xf3w:", error));
}
// Funkcja do wyświetlania postów
function loadPosts(posts) {
    postContainer.innerHTML = ''; // Czyścimy kontener
    // Dodawanie postów (do currentPostCount)
    posts.slice(0, currentPostCount).forEach((post)=>{
        const postTile = document.createElement('div');
        postTile.classList.add('post-tile');
        // Utworzenie kontenera na media
        const mediaContainer = document.createElement('div');
        mediaContainer.classList.add('media-container');
        // Sprawdzenie, czy post zawiera obraz/film i dodanie odpowiedniego elementu
        const mediaElement = document.createElement(post.media_url.includes('.mp4') ? 'video' : 'img');
        mediaElement.src = post.media_url;
        mediaElement.alt = 'Post Image';
        mediaElement.classList.add('post-image');
        mediaElement.controls = post.media_url.includes('.mp4'); // Dodaj kontrolki, jeśli to film
        mediaContainer.appendChild(mediaElement); // Dodaj media do kontenera
        postTile.appendChild(mediaContainer); // Dodaj kontener do kafelka postu
        // Sformatowanie daty
        const postDate = new Date(post.timestamp);
        const formattedDate = `${postDate.getDate().toString().padStart(2, '0')}-${(postDate.getMonth() + 1).toString().padStart(2, '0')}-${postDate.getFullYear()}`;
        // Tworzenie sekcji z opisem
        const postContent = document.createElement('div');
        postContent.classList.add('post-content');
        postContent.innerHTML = `<p>${post.caption || ''}</p>`;
        // Tworzenie kontenera dla daty i przycisku "Czytaj dalej"
        const dateAndButtonContainer = document.createElement('div');
        dateAndButtonContainer.classList.add('date-button-container');
        // Dodanie daty
        const dateElement = document.createElement('p');
        dateElement.textContent = formattedDate;
        // Tworzenie przycisku "Czytaj dalej"
        const readMoreButton = document.createElement('button');
        readMoreButton.textContent = 'Czytaj dalej';
        readMoreButton.classList.add('read-more-button');
        readMoreButton.addEventListener('click', (e)=>{
            e.stopPropagation(); // Zatrzymaj propagację kliknięcia
            showPopup(post); // Wywołaj funkcję do otwierania popupu
        });
        // Dodanie daty i przycisku do kontenera
        dateAndButtonContainer.appendChild(dateElement);
        dateAndButtonContainer.appendChild(readMoreButton);
        // Dodaj kontener daty i przycisku do postContent
        postContent.appendChild(dateAndButtonContainer);
        postTile.appendChild(postContent);
        postContainer.appendChild(postTile);
    });
    // Ustaw widoczność przycisku "Zobacz więcej"
    loadMoreBtn.style.display = currentPostCount >= posts.length ? 'none' : 'block'; // Ukryj lub pokaż przycisk
}
function showPopup(post) {
    const popupContainer = document.querySelector('.popupContainer');
    popupContainer.classList.add('open');
    const popup = document.getElementById('popup');
    popup.innerHTML = ''; // Wyczyść poprzednie zawartości
    // Dodaj przycisk zamknięcia "X"
    const closeButton = document.createElement('button');
    closeButton.classList.add('popup-close-button');
    closeButton.innerHTML = 'X';
    closeButton.onclick = hidePopup; // Funkcja zamykająca popup
    popup.appendChild(closeButton);
    // Stwórz kontener dla mediów
    const mediaContainer = document.createElement('div');
    mediaContainer.classList.add('popup-image-container');
    // Dodaj dodatkowe media (jeśli istnieją)
    if (post.children) post.children.data.forEach((child)=>{
        const childMediaElement = document.createElement(child.media_url.includes('.mp4') ? 'video' : 'img');
        childMediaElement.src = child.media_url;
        childMediaElement.alt = 'Post Image';
        childMediaElement.classList.add('popup-image');
        childMediaElement.controls = child.media_url.includes('.mp4');
        mediaContainer.appendChild(childMediaElement);
    });
    else {
        // Dodaj główny element media (obraz lub film)
        const mainMediaElement = document.createElement(post.media_url.includes('.mp4') ? 'video' : 'img');
        mainMediaElement.src = post.media_url;
        mainMediaElement.alt = 'Post Image';
        mainMediaElement.classList.add('popup-image');
        mainMediaElement.controls = post.media_url.includes('.mp4');
        mediaContainer.appendChild(mainMediaElement);
    }
    popup.appendChild(mediaContainer); // Dodaj kontener mediów do popupu
    // Dodaj opis i datę
    const popupContent = document.createElement('div');
    popupContent.classList.add('popup-content');
    const postDate = new Date(post.timestamp);
    const formattedDate = `${postDate.getDate().toString().padStart(2, '0')}-${(postDate.getMonth() + 1).toString().padStart(2, '0')}-${postDate.getFullYear()}`;
    popupContent.innerHTML = `<pre>${post.caption || ''}</pre><div class="popup-footer"><p>${formattedDate}</p> <button onclick="hidePopup()">Zamknij</button> </div>`;
    popup.appendChild(popupContent);
    popup.style.opacity = '1';
    popup.style.display = 'block';
}
// Wczytaj posty na początku
fetchPosts();
// Obsługa kliknięcia przycisku "Zobacz więcej"
loadMoreBtn.addEventListener('click', ()=>{
    currentPostCount += 6; // Zwiększ liczbę wyświetlanych postów
    fetchPosts(); // Ponownie wczytaj posty
});

//# sourceMappingURL=news.65b8e510.js.map
